import axios from 'axios'
import { getRegion, getCurrentLocale } from '@insight/toolkit-utils'
import { INSIGHT_CURRENT_LOCALE_COOKIE_NAME } from '@constants'

export const getLocaleMetadata = () => {
  const currentLocale = getCurrentLocale(INSIGHT_CURRENT_LOCALE_COOKIE_NAME)
  const locale = currentLocale.toUpperCase()
  const splitLocale = locale.split('_')
  const countryCode = splitLocale[1]
  const language = splitLocale[0]

  return { market: countryCode, language, locale }
}

export const getCnetConfig = async () => {
  const locale = getRegion(INSIGHT_CURRENT_LOCALE_COOKIE_NAME)
  const metadata = getLocaleMetadata()
  const currentLocale = getCurrentLocale(
    INSIGHT_CURRENT_LOCALE_COOKIE_NAME
  )?.split('_')[1]
  let selectedLocale = currentLocale
  let key = 'DEFAULT'
  
  const newCnetConfigEnabled = window.flags && window.flags['GNA-16081-Config-Data-Service'];
  const serviceUrl = newCnetConfigEnabled ? '/insightweb/config/cnet' : '/aemServices/config.cnet-configs.json';
  const { data } = await axios.get(serviceUrl)
 
  // Check mapping for current c-code
  if (data.market_mapping[currentLocale]) {
    selectedLocale = data.market_mapping[currentLocale]
  }
  if (locale === 'EMEA') key = selectedLocale
  // Pass the current c-code to find the account
  const config = data.accounts[key]
  return { ...config, ...metadata }
}
